export const EVENT = {
  SHOW_MODEL_CONFIG_MODAL: 'showModelConfig',
  REFRESH_MEMORIES: 'refreshMemories',
  LOGOUT: 'logout',
  SHOW_REGISTER_MODAL: 'showRegisterModal',
  PERSONA_CHANGED: 'personaChanged'
};
